export const choiseChipSizes = {
  l: 'l',
  m: 'm',
}

export const chioseChipPaddingsRem = {
  [choiseChipSizes.l]: '0.75rem 1rem',
  [choiseChipSizes.m]: '0.5rem 0.75rem',
}

export const chioseChipPaddingsPx = {
  [choiseChipSizes.l]: '12px 16px',
  [choiseChipSizes.m]: '8px 12px',
}

export const chioseChipBorderRadiusesRem = {
  [choiseChipSizes.l]: '1rem',
  [choiseChipSizes.m]: '0.625rem',
}

export const chioseChipBorderRadiusesPx = {
  [choiseChipSizes.l]: '16px',
  [choiseChipSizes.m]: '16px',
}

export const choiseChipTextSizes = {
  l: 'pL',
  m: 'pM',
} as const
